module.exports = __webpack_public_path__ + "img/symbol_9.c006275f.png";